function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Logger from '../../../../../wdh-foundation/wdh-logger/wdh-logger';

/**
 * Translation manager to get texts from the Json created in Sitecore
 * @memberOf module:wdh-feature-b2b
 */
var TranslationMgr = /*#__PURE__*/function () {
  function TranslationMgr() {
    _classCallCheck(this, TranslationMgr);
  }
  return _createClass(TranslationMgr, [{
    key: "loadAllTranslations",
    value:
    /**
     * Load translations from a script element
     * @param {Object} element - The script element containing the translation json dictionary
     */
    function loadAllTranslations(element) {
      this.translations = [];
      var loadedTranslations = JSON.parse(element.innerHTML);
      for (var i = 0; i < loadedTranslations.length; i += 1) {
        var _loadedTranslations$i = loadedTranslations[i],
          key = _loadedTranslations$i.key,
          value = _loadedTranslations$i.value;
        var splitKey = key.split('/');
        var newKey = splitKey[splitKey.length - 1];
        this.translations.push({
          key: newKey,
          value: value
        });
      }
    }
  }, {
    key: "hasTranslation",
    value: function hasTranslation(key) {
      if (this.translations === undefined) {
        return false;
      }
      var translation = this.translations.find(function (e) {
        return e.key === key;
      });
      return translation !== undefined;
    }

    /**
     * Get translation for a given key
     * @param {String} key  Key of the text to get from the translations
     * @returns {String}    Found translation or error text if not found
     */
  }, {
    key: "getTranslation",
    value: function getTranslation(key) {
      if (this.translations === undefined) {
        return 'Translations are not loaded';
      }
      var translation = this.translations.find(function (e) {
        return e.key === key;
      });
      if (translation !== undefined) {
        return this.translations.find(function (e) {
          return e.key === key;
        }).value;
      }
      Logger.warn("[Untranslated(".concat(key, ")]"));
      return "[Untranslated(".concat(key, ")]");
    }

    /**
     * Get translation for a given key + replace placeholder values with real values
     * @param {String} key      Key of the text to get from the translations
     * @param {Object} element  key/value list with replacements (key = placeholder, value = actual value)
     * @returns {String}        Found translation with replacement or error text if not found
     */
  }, {
    key: "getTranslationWithReplacement",
    value: function getTranslationWithReplacement(key, replacements) {
      var translation = this.getTranslation(key);
      for (var index = 0; index < replacements.length; index += 1) {
        translation = translation.replace(replacements[index].key, replacements[index].value);
      }
      return translation;
    }

    /**
     * Get translation for a given key + add html linebreaks
     * @param {String} key  Key of the text to get from the translations
     * @returns {String}    Found translation with linebreaks or error text if not found
     */
  }, {
    key: "getMultilineTranslation",
    value: function getMultilineTranslation(key) {
      var text = this.getTranslation(key);
      return text.replace('\n', '<br/>');
    }
  }]);
}();
var TranslationManager = new TranslationMgr();
export default TranslationManager;